<template>
  <div class="container-header">

    <div class="mauto">
      <div class="logo" id="com_logo" editok="online">
        <a href="/">
          <img alt="中国科学资讯网  Chinese Science &amp; Technology Post" src="../assets/images/202005061345108073.png"></a>
      </div>
      <div class="i_nav" id="com_mainmenu" editok="online">
        <div id="smoothmenu1" class="ddsmoothmenu">
          <ul>
            <li class="navline" v-for="(item, index) in navList" :key="index">
              <a v-if="item.select" :href="item.path" class="navactive">{{item.label}}</a>
              <a v-else :href="item.path" class="nava">{{item.label}}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Header",
  mounted() {
    const routeName = this.$route.name
    for (const i in this.navList) {
      if (this.navList[i].pathName === routeName) {
        this.navList[i].select = true
      } else {
        this.navList[i].select = false
      }
    }
  },
  data() {
    return {
      navList: [
        {
          id: 0,
          pathName: 'home',
          select: true,
          path: '/',
          label: '首页'
        },
        {
          id: 1,
          pathName: 'guoNeiZiXun',
          select: false,
          path: '/#/guoNeiZiXun',
          label: '国内资讯'
        },
        {
          id: 2,
          pathName: 'guoWaiZiXun',
          select: false,
          path: '/#/guoWaiZiXun',
          label: '国外资讯'
        },
        {
          id: 3,
          pathName: 'zuiXinZiXun',
          select: false,
          path: '/#/zuiXinZiXun',
          label: '最新资讯'
        },
        {
          id: 4,
          pathName: 'hangYeZiXun',
          select: false,
          path: '/#/hangYeZiXun',
          label: '行业资讯'
        },
        {
          id: 5,
          pathName: 'shiShiXinWen',
          select: false,
          path: '/#/shiShiXinWen',
          label: '时事新闻'
        }
      ]
    }
  }
}
</script>

<style scoped>
  .container-header {
    width: 100%;
    height: auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background: url("../../src/assets/images/201910211557345428.png");
  }
  .navline {
    margin: 0 18px;
  }
</style>